/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const FILTROS = [];
const SEARCH_FIELDS = [
  "nombrefantasia",
  "_certificadoTipoNombre",
  "_clienteRazonSocial",
  "_clienteNombreFantasia"
];

export default function SolicitudesPendientes({ toast }) {
  const [solicitudes, setSolicitudes] = useState();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/solicitudespendientes",
      null,
      (respuesta) => {
        setSolicitudes(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar solicitudes",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (!loading && (!solicitudes || solicitudes.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  const clienteBody = (solicitud) => {
    return solicitud.cliente.nombrefantasia &&
      solicitud.cliente.nombrefantasia !== solicitud.cliente.razonsocial
      ? `${solicitud.cliente.razonsocial} (${solicitud.cliente.nombrefantasia})`
      : solicitud.cliente.razonsocial;
  };

  const fechaBody = (solicitud) => {
    return formatFecha(solicitud.fecha);
  };

  const datos = (solicitudes || []).map((s) => ({
    ...s,
    _certificadoTipoNombre: s.certificadotipo?.nombre,
    _clienteRazonSocial: s.cliente?.razonsocial,
    _clienteNombreFantasia: s.cliente?.nombrefantasia
  }));

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab header={`Solicitudes (${solicitudes.length})`}>
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          nombreArchivo="solicitudes_pendientes"
          onRowClick={(e) => {
            const url = `/procesos/solicitudes/${e.data.id}?volver=/`;
            e.originalEvent.metaKey || e.originalEvent.ctrlKey
              ? window.open(url, "_blank")
              : navigate(url);
          }}
          stripedRows
          emptyMessage="No hay solicitudes pendientes"
          css={{
            "& .p-datatable-tbody > tr": {
              cursor: "pointer"
            }
          }}
        >
          <Column header="Cliente" body={clienteBody} />
          <Column header="Solicitud" field="nombrefantasia" />
          <Column header="Tipo de certificado" field="certificadotipo.nombre" />
          <Column header="Fecha" body={fechaBody} style={{ width: "10em" }} />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
